import { useMemo } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle } from '@fortawesome/pro-solid-svg-icons'

import { hasUnreadMessages } from '../../utils/entities/chatRoom'

const BLUE = 'rgb(60, 141, 188)'
const ORANGE = 'rgb(250, 173, 20)'
const RED = 'red'

const ShiftMessagingIndicator = ({ shift, status, pinned = false }) => {
  const color = useMemo(() => {
    // A pinned comment deserves to stand out on its own, but an unread message outranks it.
    const restingColor = pinned ? ORANGE : BLUE

    if (shift && shift.chatRooms && shift.chatRooms.length > 0) {
      return hasUnreadMessages(shift.chatRooms[0]) ? RED : restingColor
    }

    if (status === 2) {
      return RED
    }

    return status === 1 || pinned ? restingColor : 'grey'
  }, [shift, status, pinned])

  if (pinned) {
    return <div className='pinned-comment-corner' style={{ borderTopColor: color }} />
  }

  return (
    <div style={{ position: 'absolute', top: '-8px', left: 'calc(100% - 5px)', zIndex: 1 }}>
      <FontAwesomeIcon icon={faCircle} color={color} size='sm' />
    </div>
  )
}

export default ShiftMessagingIndicator
